// extracted by mini-css-extract-plugin
module.exports = {"center":"Center_center__OsABS","fade_in":"Center_fade_in__I0EcO"};